'use strict';

module.exports = {
    createDelaySession: function () {
        if ($('input[name=mbb-chat-enabled]').length > 0 && $('input[name=mbb-chat-enabled]').val() === 'true') {
            let delaySeconds = $('input[name=mbb-chat-delay-seconds]').val() * 1000;
            let chatEndTime = window.sessionStorage.getItem('mbbChatEndTime');
            if (!chatEndTime) {
                let expiryTime = Date.now() + delaySeconds;
                window.sessionStorage.setItem('mbbChatEndTime', expiryTime);
            }
        }
    },

    loadScript: function () {
        if ($('input[name=mbb-chat-enabled]').length > 0 && $('input[name=mbb-chat-enabled]').val() === 'true') {
            let chatEndTime = window.sessionStorage.getItem('mbbChatEndTime');
            let isScriptLoaded = 'mbbChatScriptLoaded';
            let timerInterval;

            if (sessionStorage.getItem(isScriptLoaded)) {
                window.initEmbeddedMessaging();
            } else {
                timerInterval = setInterval(() => {
                    const now = Date.now();
                    const remaining = chatEndTime - now;
                    if (!sessionStorage.getItem(isScriptLoaded)) {
                        if (remaining <= 0) {
                            window.initEmbeddedMessaging();
                            sessionStorage.setItem(isScriptLoaded, 'true');
                        }
                    } else {
                        clearInterval(timerInterval);
                    }
                }, 1000);
            }
        }
    }
};